export const DocumentTypesEnum = {
    passport: { label: 'Passport', value: 'PASSPORT' },
    visa: { label: 'Visa', value: 'VISA' },
    nationalId: { label: 'National ID', value: 'NATIONAL_ID' },
    drivingLicense: { label: 'Driving License', value: 'DRIVING_LICENSE' },
    residencePermit: { label: 'Residence Permit', value: 'RESIDENCE_PERMIT' },
    companyRegistrationCertificate: { label: 'Company Registration Certificate', value: 'COMPANY_REGISTRATION_CERTIFICATE' },
    taxIdentificationNumber: { label: 'Tax Identification Number (TIN)', value: 'TAX_IDENTIFICATION_NUMBER' },
    bankStatements: { label: 'Bank Statements', value: 'BANK_STATEMENTS' },
    utilityBills: { label: 'Utility Bills', value: 'UTILITY_BILLS' },
    leaseAgreements: { label: 'Lease Agreements', value: 'LEASE_AGREEMENTS' },
    healthInsurance: { label: 'Health Insurance', value: 'HEALTH_INSURANCE' },
    employmentContract: { label: 'Employment Contract', value: 'EMPLOYMENT_CONTRACT' },
    salaryCertificate: { label: 'Salary Certificate', value: 'SALARY_CERTIFICATE' },
    businessLicense: { label: 'Business License', value: 'BUSINESS_LICENSE' },
    emiratesId: { label: 'Emirates ID', value: 'EMIRATES_ID' },
    policeClearanceCertificate: { label: 'Police Clearance Certificate', value: 'POLICE_CLEARANCE_CERTIFICATE' },
    auditReport: { label: 'Audit Report', value: 'AUDIT_REPORT' },
    shareholdingCertificate: { label: 'Shareholding Certificate', value: 'SHAREHOLDING_CERTIFICATE' },
    workPermit: { label: 'Work Permit', value: 'WORK_PERMIT' },
    invoice: { label: 'Invoice', value: 'INVOICE' },
    other: { label: 'Other', value: 'OTHER' },
  };
  